import React from 'react';
import { Link } from 'react-router-dom';
import { getArticle } from './articles';

function Body({ items = [] }) {
  return items.map((b, i) => {
    if (b.type === 'p') {
      return (
        <p key={i} className="text-sm leading-relaxed text-surface-text dark:text-surface-dark-text mb-2">
          {b.text}
        </p>
      );
    }
    if (b.type === 'list') {
      return (
        <ul key={i} className="list-disc list-inside text-sm text-surface-text dark:text-surface-dark-text mb-2 space-y-0.5 marker:text-continuum-500">
          {b.items.map((it, j) => <li key={j}>{it}</li>)}
        </ul>
      );
    }
    if (b.type === 'tip') {
      return (
        <div key={i} className="mb-2 p-2 rounded-thin text-xs bg-continuum-50 dark:bg-continuum-900/30 text-continuum-800 dark:text-continuum-200 border border-continuum-200/40 dark:border-continuum-700/40">
          💡 <strong>Tip:</strong> {b.text}
        </div>
      );
    }
    if (b.type === 'warn') {
      return (
        <div key={i} className="mb-2 p-2 rounded-thin text-xs bg-amber-50 dark:bg-amber-900/30 text-amber-800 dark:text-amber-200 border border-amber-200/40 dark:border-amber-700/40">
          ⚠️ <strong>Warning:</strong> {b.text}
        </div>
      );
    }
    if (b.type === 'kbd') {
      return (
        <p key={i} className="text-xs font-mono mb-2 px-2 py-1 rounded-thin bg-surface-subtle dark:bg-surface-dark-subtle inline-block">
          {b.text}
        </p>
      );
    }
    return null;
  });
}

export default function HelpDrawer({ moduleKey, onClose }) {
  const article = getArticle(moduleKey);

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        className="fixed inset-0 bg-black/30 z-40"
      />
      {/* Drawer */}
      <div className="fixed top-0 right-0 h-full w-[480px] max-w-[100vw] z-50 bg-surface-panel dark:bg-surface-dark-panel border-l border-surface-border dark:border-surface-dark-border shadow-2xl flex flex-col">
        <div className="px-4 py-3 border-b border-surface-border dark:border-surface-dark-border flex items-center justify-between">
          <div>
            <div className="text-xs text-surface-muted uppercase tracking-wider">Help</div>
            <div className="text-sm font-semibold">{article ? article.title : 'No help available'}</div>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/help"
              onClick={onClose}
              className="px-2 py-1 text-xs rounded-thin border border-surface-border dark:border-surface-dark-border hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle"
              title="See all help articles"
            >
              📚 All help
            </Link>
            <button
              onClick={onClose}
              className="px-2 py-1 text-xs rounded-thin border border-surface-border dark:border-surface-dark-border hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle"
            >
              ✕ Close
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-auto p-4">
          {!article ? (
            <div className="text-sm text-surface-muted">
              No dedicated help article is available for this view yet.
              {' '}
              <Link to="/help" onClick={onClose} className="text-continuum-600 dark:text-continuum-300 hover:underline">
                Browse all topics →
              </Link>
            </div>
          ) : (
            article.sections.map((s, i) => (
              <div key={i} className="mb-5">
                <h3 className="text-sm font-semibold mb-1 text-continuum-700 dark:text-continuum-200">{s.heading}</h3>
                <Body items={s.body} />
              </div>
            ))
          )}
          <div className="mt-6 pt-3 border-t border-surface-border dark:border-surface-dark-border text-xs text-surface-muted">
            Still stuck? Ask your supervisor or admin.
          </div>
        </div>
      </div>
    </>
  );
}
